import { css, createGlobalStyle } from 'styled-components';

const fieldControlHeight = '34px';
const fieldFontSize = '16px';
const commonInput = css`
  color: #313b40;
  font-weight: 400;
  border: 1px solid #b9b9b9;
  font-size: ${fieldFontSize};
  border-radius: 3px;
  height: ${fieldControlHeight};
  padding-left: 10px;
  padding-right: 10px;
`;

const GlobalStyle = createGlobalStyle`
  p {
    margin: 0;
  }

  .ant-btn {
    font-size: 13px;
    height: 34px;

    &:not(:disabled) {
      box-shadow: 0 2px 5px 0 rgba(0,0,0,.26);
    }
    &.ant-btn:not(.ant-btn-circle):not(.ant-btn-circle-outline).ant-btn-icon-only {
      padding-right: 10px;
      padding-left: 10px;
    }
  }

  .ant-legacy-form-item-label {
    height: 34px !important;
    line-height: 36px !important;
  }
  .ant-legacy-form-item-label label {
    color: rgba(100, 116, 124, 0.85) !important;
    font-weight: 400 !important;
    font-size: 13px !important;
  }

  .ant-legacy-form-item-control {
    line-height: 20px !important;
    color: #313B40 !important;
    font-weight: 400 !important;

    .ant-legacy-form-explain {
      font-size: ${fieldFontSize} !important;
    }
  }

  .ant-input, .ant-time-picker-input {
    ${commonInput};
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .ant-input-number {
    ${commonInput};
  }

  .ant-select-selection {
    ${commonInput};

    .ant-select-selection__rendered {
      line-height: ${fieldControlHeight};
    }
    .ant-select-arrow {
      font-size: ${fieldFontSize};
    }
  }

  .ant-select-lg .ant-select-selection--single {
    height: ${fieldControlHeight};
  }

  .ant-time-picker {
    width: auto;
  }

  .ant-time-picker-large .ant-time-picker-input {
    height: initial;
  }

  .ant-select-selection--multiple > ul > li,
  .ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
    margin-top: 3px;
    height: 25px;
    line-height: 25px;
  }
`;

export default GlobalStyle;
